export const plantKeys = {
  all: ['plants'] as const,
  lists: () => [...plantKeys.all] as const,
  list: (filters?: Record<string, unknown>) =>
    filters ? ([...plantKeys.lists(), filters] as const) : plantKeys.lists(),
  overview: () => [...plantKeys.all, 'overview'] as const,
  ranking: () => [...plantKeys.all, 'ranking'] as const,
  reports: () => [...plantKeys.all, 'reports'] as const,
  details: () => [...plantKeys.all, 'detail'] as const,
  detail: (plantId: string) => [...plantKeys.all, plantId] as const,
  plantOverview: (plantId: string) => [...plantKeys.detail(plantId), 'overview'] as const,
  plantDevices: (plantId: string) => [...plantKeys.detail(plantId), 'devices'] as const,
  plantDevicesOverview: (plantId: string) =>
    [...plantKeys.detail(plantId), 'devices', 'overview'] as const,
  plantEvents: (plantId: string) => [...plantKeys.detail(plantId), 'events'] as const,
  plantSchedules: (plantId: string) => [...plantKeys.detail(plantId), 'schedules'] as const,
  plantScheduleRevisions: (plantId: string, scheduleId: string) =>
    [...plantKeys.plantSchedules(plantId), scheduleId, 'revisions'] as const,
  plantUptime: (plantId: string) => [...plantKeys.detail(plantId), 'uptime'] as const,
  plantControlPanel: (plantId: string) =>
    [...plantKeys.detail(plantId), 'control-panel'] as const,
  plantControlPanelScripts: (plantId: string) =>
    [...plantKeys.plantControlPanel(plantId), 'scripts'] as const,
  plantUsers: (plantId: string) => [...plantKeys.detail(plantId), 'users'] as const,
  plantReport: (plantId: string) => [...plantKeys.detail(plantId), 'report'] as const,
};
